// react
import React, { useMemo } from 'react';

// third-party
// import { Helmet } from 'react-helmet-async';
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import BlockPosts from '../blocks/BlockPosts';
// import BlockSlideShow from '../blocks/BlockSlideShow';
import BlockSlideBox from '../blocks/BlockSlideBox';
import Charts from '../blocks/Charts';

function HomePageOne() {
    return (
        <React.Fragment>
            {useMemo(() => <BlockSlideBox location="home" />, [])}
            {useMemo(() => <Charts location="home" />, [])}
            <div className="news-ballina">
                <div className="news-ballina-section">
                    <div className="news-title">
                        <Link className="event-btn" to="/News"><h3><FormattedMessage id="news-home-title" defaultMessage="Lajmet & Ngjarje" /></h3></Link>
                    </div>
                    {useMemo(() => <BlockPosts title="Latest News" layout="grid-nl" />, [])}

                </div>
            </div>
        </React.Fragment>
    );
}

export default HomePageOne;
